import { Component } from '@theme/component';
import { morph } from '@theme/morph';

/**
 * A custom element that switches the entire displayed product (not a variant)
 * within the closest `featured-product-information` section, by re-fetching
 * that section rendered at the target product's own URL and morphing it in.
 */
export default class ProductSwitcher extends Component {
  /** @type {AbortController | undefined} */
  #abortController;

  /**
   * @param {Event} event
   */
  switchProduct(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.getAttribute('aria-current') === 'true') return;

    const productUrl = target.dataset.productUrl;
    const sectionId = this.dataset.sectionId;
    if (!productUrl || !sectionId) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    this.setAttribute('data-loading', 'true');

    const requestUrl = `${productUrl}?section_id=${sectionId}`;

    fetch(requestUrl, { signal: this.#abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newSection = html.querySelector('featured-product-information');
        const currentSection = this.closest('featured-product-information');

        if (!newSection || !currentSection) return;

        morph(currentSection, newSection);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.error(error);
      })
      .finally(() => {
        this.removeAttribute('data-loading');
      });
  }
}

if (!customElements.get('product-switcher')) {
  customElements.define('product-switcher', ProductSwitcher);
}
